import DateString from 'app/content/components/date-string';
import type React from 'react';
import TextCell from './text-cell';

export type DateCellProps = {
  readonly value?: any;
};

export function getDateTableCell(formatString: string, emptyValue = 'n/a'): React.FC<DateCellProps> {
  const DateCell: React.FC<DateCellProps> = ({ value }: DateCellProps) => (
    <TextCell title={value}>{value ? <DateString date={value} formatString={formatString} /> : emptyValue}</TextCell>
  );
  return DateCell;
}
